import React from 'react';
import { useTranslation } from 'react-i18next';

// Barre de progression de l'envoi des photos d'un invité (2026-10-23) : « Photo 3 sur 12 », pourcentage global et barre.
// `fait` : photos déjà envoyées ; `total` : photos choisies ; `fraction` (0..1) : avancement de la photo en cours.
export default function UploadProgress({ fait, total, fraction = 0 }) {
  const { t } = useTranslation('collective');
  if (!total) return null;
  const global = Math.min(1, (fait + Math.max(0, Math.min(1, fraction))) / total);
  const pourcent = Math.round(global * 100);
  const enCours = Math.min(total, fait + 1);
  return (
    <div className="upload-progress" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pourcent} aria-label={t('upload.aria')}>
      <div className="upload-progress-label">
        <span>{fait >= total ? t('upload.finishing') : t('upload.photoOf', { current: enCours, total })}</span>
        <b>{pourcent} %</b>
      </div>
      <div className="upload-progress-track"><div className="upload-progress-fill" style={{ width: `${pourcent}%` }} /></div>
      <p className="upload-progress-hint">{t('upload.keepOpen')}</p>
    </div>
  );
}
